
<template>
  <div id="app" ref="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  data () {
    return {
      showPage: false
    }
  },
  created () {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 20 + 'px'
    $(window).bind('resize', () => {
      document.documentElement.style.fontSize = document.documentElement.clientWidth / 20 + 'px'
      let width = document.getElementById('yk-layout').clientWidth
      this.$store.commit('set_pageWidth', width)      
    })
  },  
  mounted () {
  },
  methods: {
  },
  components: {}
}
</script>
<style scoped lang="stylus">
</style>
